export const getAssetImageUrl = (imgPath: string) => {
  return require(`../assets/${imgPath}`);
}

export const getCurrentEnv = () => {
  let env = 'production';
  const hostName = window.location.hostname;
  if (hostName.indexOf('localhost') != -1 || hostName.indexOf('qa-') != -1 || hostName.indexOf('dev-') != -1) {
    env = 'development';
  } else if (hostName.indexOf('cloudfront') != -1) {
    env = 'qa';
  }
  return env;
}

export const SUPPORT_ENV = {
  dev: 'development',
  qa: 'qa',
  prod: 'production'
}
